module.exports = __webpack_public_path__ + "img/ifsc-code.f95bb42d.webp";